export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className?: string,
  children?: (Node | string)[],
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (children) {
    for (const c of children) {
      node.append(typeof c === 'string' ? document.createTextNode(c) : c);
    }
  }
  return node;
}

export function button(label: string, className = 'btn', onClick?: () => void): HTMLButtonElement {
  const b = el('button', className, [label]);
  if (onClick) b.addEventListener('click', onClick);
  return b;
}

export function clear(node: HTMLElement): void {
  node.replaceChildren();
}
